export const authServer = "https://authjs.web3auth.io";
